<template>
  <div
    class="diy-coupon"
    v-if="datalist.length"
    :style="'background:'+ itemStyle.background +'; padding:'+itemStyle.paddingTop +'px 0;'"
  >
    <div :style="'overflow-x:'+ true ? 'sroll': ''">
      <div class="coupon-wrapper" v-for="(dataItem,index) in datalist" :key="index">
        <div :class="'coupon-item color__'+dataItem.state.value ? dataItem.color.p : 'gray'">
          <i class="before" :style="'background:'+itemStyle.background"/>
          <div class="left-content dis-flex flex-dir-column flex-x-center flex-y-center">
            <div class="content-top">
              <block v-if="dataItem.coupon_type.value == 10">
                <p class="f-30">￥</p>
                <p class="price">{{ dataItem.reduce_price }}</p>
              </block>
              <p class="price" v-if="dataItem.coupon_type.value == 20">{{ dataItem.discount }}折</p>
            </div>
            <div class="content-bottom">
              <p class="f-22">满{{ dataItem.min_price }}元可用</p>
            </div>
          </div>
          <div
            class="right-receive dis-flex flex-x-center flex-y-center"
            @click="receiveTap(dataItem.coupon_id,index)"
            :data-index="index"
            :data-state="dataItem.state.value"
            :data-coupon-id="dataItem.coupon_id"
          >
            <div v-if="dataItem.state.value" class="dis-flex flex-dir-column">
              <p>立即</p>
              <p>领取</p>
            </div>
            <div v-if="!dataItem.state.value" class="state">
              <p>{{ dataItem.state.p }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
import { ReceiveCoupon } from "../../apis/https.js";
import { getSessionStorage } from "../../utils/storage.js";
export default {
  props: ["itemIndex", "itemStyle", "datalist"],
  data() {
    return {
      token: ""
    };
  },
  created() {},
  activated() {},
  methods: {
    receiveTap: function(id,index) {
      this.token = getSessionStorage("login_token");
      if (this.token != undefined) {
        ReceiveCoupon(id,this.token)
          .then(res => {
            datalist[index].state.value="已领取"
            datalist[index].state.p="已领取"
          })
          .catch(e => {});
      }
      //   App._post_form('user.coupon/receive', {
      //     coupon_id: dataset.couponId
      //   }, function(result) {
      //     App.showSuccess(result.msg);
      //     _this.setData({
      //       ['dataList[' + dataset.index + '].state']: {
      //         value: 0,
      //         p: '已领取'
      //       }
      //     });
      //   });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-coupon {
  white-space: nowrap;
  font-size: 0;
}

.diy-coupon .coupon-item {
  width: 175px;
  height: 175px;
  position: relative;
  color: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.diy-coupon .coupon-item i.before {
  content: "";
  position: absolute;
  z-index: 1;
  width: 20px;
  height: 20px;
  top: 50%;
  left: -0.8rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  -webkit-border-radius: 80%;
  border-radius: 80%;
  background-color: #fff;
}

.diy-coupon .coupon-wrapper {
  display: inline-block;
  padding: 0 6px;
}

.diy-coupon .coupon-item .left-content {
  position: relative;
  width: 70%;
  height: 100%;
  background-color: #e5004f;
  float: left;
}

.diy-coupon .coupon-item .left-content .content-top .price {
  font-size: 22px;
}

.diy-coupon .coupon-item.color__blue .left-content {
  background: linear-gradient(-125deg, #57bdbf, #2f9de2);
}

.diy-coupon .coupon-item.color__red .left-content {
  background: linear-gradient(-128deg, #ff6d6d, #ff3636);
}

.diy-coupon .coupon-item.color__violet .left-content {
  background: linear-gradient(-113deg, #ef86ff, #b66ff5);
}

.diy-coupon .coupon-item.color__yellow .left-content {
  background: linear-gradient(-141deg, #f7d059, #fdb054);
}

.diy-coupon .coupon-item.color__gray .left-content {
  background: linear-gradient(-113deg, #bdbdbd, #a2a1a2);
}

.diy-coupon .coupon-item.color__gray .right-receive {
  background-color: #949494;
}

.diy-coupon .coupon-item .right-receive {
  width: 30%;
  height: 100%;
  background-color: #4e4e4e;
  p-align: center;
  float: right;
}

.diy-coupon .coupon-item .right-receive p {
  font-size: 13px;
}
</style>